import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/app.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { LanguageProvider } from "./i18n";
// Side-effect import: registers the global gesture listener and starts
// pre-rendering audio buffers immediately, so any page (including home,
// login, admin) primes the sound system — the first scan after navigation
// to a scan-flow page plays from the buffer instead of falling back to
// live oscillator synthesis.
import "./components/helpers/audioPlayer";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <BrowserRouter>
        <LanguageProvider>
            <App />
        </LanguageProvider>
    </BrowserRouter>
);

// Remove splash loader after React mounts
const splash = document.getElementById("splash-loader");
if (splash) {
    splash.classList.add("hide");
    setTimeout(() => splash.remove(), 300);
}

// Lock orientation to natural portrait — prevents 180-degree flip on Zebra devices
try {
    window.screen.orientation.lock("portrait-primary").catch(() => {});
} catch { /* Screen Orientation API not supported */ }

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker for PWA installability
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/service-worker.js')
            .then((registration) => {
                // Check for updates every 60 minutes
                setInterval(() => registration.update(), 60 * 60 * 1000);
            })
            .catch((error) => {
                console.error('[SW] Registration failed:', error);
            });
    });
}
